/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Workout_Set_NumberInputs */

const en_us2_workout_set_number = /** @type {(inputs: Workout_Set_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set ${i?.n}`)
};

const pt_br2_workout_set_number = /** @type {(inputs: Workout_Set_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Série ${i?.n}`)
};

const es_419_workout_set_number = /** @type {(inputs: Workout_Set_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie ${i?.n}`)
};

const pt_pt2_workout_set_number = /** @type {(inputs: Workout_Set_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Série ${i?.n}`)
};

const fr_fr2_workout_set_number = /** @type {(inputs: Workout_Set_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Série ${i?.n}`)
};

const de_de2_workout_set_number = /** @type {(inputs: Workout_Set_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Satz ${i?.n}`)
};

const it_it2_workout_set_number = /** @type {(inputs: Workout_Set_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Set {n}" |
*
* @param {Workout_Set_NumberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_set_number = /** @type {((inputs: Workout_Set_NumberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Set_NumberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_set_number(inputs)
	if (locale === "es-419") return es_419_workout_set_number(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_set_number(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_set_number(inputs)
	if (locale === "de-DE") return de_de2_workout_set_number(inputs)
	if (locale === "it-IT") return it_it2_workout_set_number(inputs)
	return en_us2_workout_set_number(inputs)
});
export { workout_set_number as "workout.set_number" }